var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMb70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.21,19.6c-.34,0-.64-.23-.73-.57C.15,17.73-.01,16.37-.01,15s.17-2.73.49-4.04c.1-.4.51-.65.91-.54.4.1.65.51.54.91-.3,1.19-.45,2.42-.45,3.67s.15,2.48.45,3.67c.1.4-.14.81-.54.91-.06.02-.12.02-.18.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15,3.17c-6.52,0-11.83,5.31-11.83,11.83s5.31,11.83,11.83,11.83,11.83-5.31,11.83-11.83S21.52,3.17,15,3.17Zm0,22.08c-5.65,0-10.25-4.6-10.25-10.25S9.35,4.75,15,4.75s10.25,4.6,10.25,10.25-4.6,10.25-10.25,10.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1.82,9.19c.1.05.21.07.31.07.28,0,.56-.16.68-.44.75-1.64,1.78-3.1,3.05-4.32.3-.29.31-.76.02-1.06-.29-.3-.76-.31-1.06-.02-1.41,1.36-2.55,2.96-3.38,4.78-.17.38,0,.82.37.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2.82,21.18c-.17-.38-.62-.54-.99-.37-.38.17-.54.62-.37.99.83,1.82,1.96,3.42,3.38,4.78.15.14.33.21.52.21s.39-.08.54-.23c.29-.3.28-.77-.02-1.06-1.27-1.23-2.3-2.68-3.05-4.32Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m27.06,8.82c.13.28.4.44.68.44.1,0,.21-.02.31-.07.38-.17.54-.62.37-.99-.83-1.82-1.96-3.43-3.38-4.78-.3-.29-.77-.28-1.06.02-.29.3-.28.77.02,1.06,1.27,1.22,2.3,2.68,3.05,4.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m29.39,10.96c-.1-.4-.51-.65-.91-.54-.4.1-.65.51-.54.91.3,1.19.45,2.42.45,3.67s-.15,2.48-.45,3.67c-.1.4.14.81.54.91.06.02.12.02.18.02.34,0,.64-.23.73-.57.33-1.31.49-2.66.49-4.03s-.17-2.73-.49-4.04Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m28.05,20.81c-.38-.17-.82,0-.99.37-.75,1.64-1.77,3.1-3.05,4.32-.3.29-.31.76-.02,1.06.15.15.34.23.54.23s.37-.07.52-.21c1.41-1.36,2.55-2.97,3.38-4.78.17-.38,0-.82-.37-.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMb70);
export default __webpack_public_path__ + "static/media/MB70.78ea7ccc7e1663d2cab2318cd8efe2db.svg";
export { ForwardRef as ReactComponent };